import api from '../callApi';
import humanparser from 'humanparser';
import { parseAddressNumber, parseAddressStreet } from '../addressParser';
import { relevantRepresentatives } from '../../utils/localRepresentative/parser';
import { StatesAbbreviation } from '../enums';
import { joinEnglish } from '../localRepresentative/parser';
import { copyFor } from '../../copy/copy';

const sendEmailErrorMessage = "Couldn't send email, try again later";

const getErrorMessage = errorList =>
    errorList && errorList.length ? errorList[0] : sendEmailErrorMessage;

const completeEmail = (
    apiRequestData,
    actionCompletedTime,
    values,
    localRepData,
    representativeSearch,
    emailSubject,
    emailTopic,
    emailMessage,
    isRecordVideoAction,
    answerId,
    recordVideoEmailData,
    partnerName,
    hiddenReps
) => {
    const name = humanparser.parseName(values.fullName);
    const addressParsedNumber = parseAddressNumber(values.address);
    const addressParsedStreet = parseAddressStreet(values.address);
    let representatives =
        localRepData && localRepData.representative
            ? relevantRepresentatives(representativeSearch, localRepData.representative)
                .filter(rep => rep.canBeEmailed)
                .filter(rep => !hiddenReps?.includes(rep.fullName))
            : [];
    const representativesData = representatives.map(rep => ({
        level: rep.level,
        role: rep.role,
        name: rep.fullName,
        state: rep.state,
        country: rep.country,
        districtNo: rep.districtNo,
        bioguideId: rep.bioguideId
    }));
    let address = {
        source: 1
    };

    if (representativesData.length) {
        address = {
            source: localRepData.isUserInput || Object.keys(values).length > 5 ? 0 : 1, // source: 0 = user input
            country: values.country || localRepData.address.country,
            state: values.stateId || localRepData.address.state,
            county: values.county,
            city: values.homeCity || localRepData.address.city,
            zipCode: values.postalCode || localRepData.address.zipCode,
            street: addressParsedStreet || localRepData.address.street,
            streetNo: addressParsedNumber || localRepData.address.streetNo
        };
    }

    if (isRecordVideoAction) {
        const repNames = joinEnglish(representatives.map(rep => rep.displayName));
        const districtNo = representatives.reduce(
            (acc, rep) => (!acc ? rep.districtNo : acc),
            null
        );
        const state = StatesAbbreviation[representatives[0].state && representatives[0].state.toUpperCase()];

        emailSubject = recordVideoEmailData.subject;
        emailMessage = recordVideoEmailData.body
            .replace(/@userFullName/g, values.fullName)
            .replace(/@localRepresentative/g, repNames)
            .replace(/@userVideoUrl/g, recordVideoEmailData.videoURL)
            .replace(
                /@state/g,
                state || copyFor('email', 'myState', 'recordvideo')
            )
            .replace(
                /@district/g,
                districtNo
                    ? `${copyFor('email', 'district', 'recordvideo')} ${districtNo}`
                    : copyFor('email', 'myDistrict', 'recordvideo')
            )
            .replace(/@partnerName/g, partnerName || 'Speakable');
    }

    const request = {
        ...apiRequestData,
        actionCompletedTime: actionCompletedTime,
        from: values.email,
        firstName: name.middleName
            ? name.firstName + ' ' + name.middleName
            : name.firstName,
        lastName: name.lastName || name.suffix,
        prefix: values.prefix,
        text: emailMessage || values.message,
        notifyResult: values.getUpdates,
        representatives: representativesData,
        topic: emailTopic,
        phoneNumber: values.phone,
        subject: emailSubject,
        address: address,
        answerId: answerId
    };

    const endpoint = isRecordVideoAction
        ? 'Widget/CompleteRecordVideoEmailAsync'
        : 'Widget/SendEmailAsync';

    return api.post(endpoint, request, { useFingerprint: true }).then(response => {
        if (isRecordVideoAction) return response; //for record video action, video needs to be manually approved before it is sent, so no need to error check on the front end

        let isValid = false;
        for (let i = 0; i < response.emailStatusList.length; i++) {
            if (response.emailStatusList[i].status < 2) { // >=2 means email sending error
                isValid = true;
            }
        }
        return isValid ? response : Promise.reject(getErrorMessage(response.errorList));
    });
};

export default completeEmail;
